const StatsSection = () => {
  return (
    <section className="bg-gray-50 py-12">
      <div className="max-w-[1330px] mx-auto px-4 sm:px-6 lg:px-8">
        {/* Single Card with 4 sections */}
        <div className="bg-white rounded-2xl shadow-md hover:shadow-lg transition-shadow">
          <div className="grid grid-cols-1 md:grid-cols-12 divide-y md:divide-y-0 md:divide-x divide-gray-200">
            
            {/* Logo Section - Narrower (2 columns) */}
            <div className="md:col-span-2 p-8 flex items-center justify-center">
              <img 
                src="/logooo.svg" 
                alt="iSolve RCM" 
                className="w-auto h-[100px] object-contain"
              />
            </div>

            {/* 50+ States (3 columns) */}
            <div className="md:col-span-3 p-8 flex flex-col justify-center">
              <div className="mb-3 flex items-baseline">
                <span className="text-5xl font-bold text-blue-600">50+</span>
                <span className="text-xl font-semibold text-blue-600 uppercase tracking-wide ml-2">STATES</span>
              </div>
              <p className="text-gray-600 text-base leading-relaxed">
                Delivering billing services to providers across all the U.S.
              </p>
            </div>

            {/* 50+ Specialties (3 columns) */}
            <div className="md:col-span-3 p-8 flex flex-col justify-center">
              <div className="mb-3 flex items-baseline">
                <span className="text-5xl font-bold text-blue-600">50+</span>
                <span className="text-xl font-semibold text-blue-600 uppercase tracking-wide ml-2">SPECIALTIES</span>
              </div>
              <p className="text-gray-600 text-base leading-relaxed">
                Handling billing requirements for multi-specialty practices, clinics.
              </p>
            </div>

            {/* 100% HIPAA Compliant (4 columns - widest) */}
            <div className="md:col-span-4 p-8 flex flex-col justify-center">
              <div className="mb-3 flex items-baseline">
                <span className="text-5xl font-bold text-blue-600">100%</span>
                <span className="text-xl font-semibold text-blue-600 uppercase tracking-wide ml-2">HIPAA COMPLIANT</span>
              </div>
              <p className="text-gray-600 text-base leading-relaxed">
                Our data security ensures complete protection of patient information.
              </p>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
